import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

export type AccessLevel = 'NONE' | 'READ_ONLY' | 'FULL_ACCESS';

interface RBACContextType {
    level: AccessLevel;
    isReadOnly: boolean;
    isDisabled: boolean;
}

const RBACContext = createContext<RBACContextType>({ level: 'FULL_ACCESS', isReadOnly: false, isDisabled: false });

export const RBACProvider: React.FC<{ moduleId?: string; children: React.ReactNode }> = ({ moduleId, children }) => {
    const { user } = useAuth();
    
    const value = useMemo(() => {
        if (!moduleId || !user?.permissions) return { level: 'FULL_ACCESS' as AccessLevel, isReadOnly: false, isDisabled: false };
        
        const perm = user.permissions.find((p: any) => p.moduleId === moduleId);
        const level = (perm ? perm.level : 'FULL_ACCESS') as AccessLevel;
        
        return {
            level,
            isReadOnly: level === 'READ_ONLY',
            isDisabled: level === 'READ_ONLY' || level === 'NONE'
        };
    }, [moduleId, user?.permissions]);

    return (
        <RBACContext.Provider value={value}>
            {children}
        </RBACContext.Provider>
    );
};

export const usePageRBAC = () => useContext(RBACContext);
